import Terms from './Terms';
import Privacy from './Privacy';
import Cookies from './Cookies';
import Campaign from './Campaign';

const index = {
  Terms,
  Privacy,
  Cookies,
  Campaign,
};

export default index;